// extracted by mini-css-extract-plugin
export default {"background":"pqBgHC8diZMqF5OzXwDo","error":"qd_rnicV0g5YSdYpvBXQ","errorHeader":"SZHpJ6x7Cj0aN1k5XZRX"};